import KisApiCustomPage from '../../components/kisapi/KisApiCustomPage';

import Icon from '../../assets/icon-kisapi.svg?react';
import {RouteConfig} from '@deviceinsight/ng-ui-scale-lib/api';

export default {
	relativePath: 'kisapi',
	label: {
		id: 'route.label.kisapi',
		defaultValue: 'KIS.API'
	},
	iconSvg: Icon,
	component: KisApiCustomPage,
	requiredAuthorities: ['READ_KIS_API_USER'],
	config: {
		sidebarIndex: 3
	}
} satisfies RouteConfig;
